<mat-toolbar class="dialog-title">
  <span>Recuperar contraseña</span>
  <div (click)="cerrar()" class="close-dialog">
    <i class="fas fa-times"></i>
  </div>
</mat-toolbar>

<div mat-dialog-content>
  <mat-form-field appearance="outline" class="field-meta-100">
    <mat-label>Correo Electrónico<span style="color: red;">*</span></mat-label>
    <input matInput [(ngModel)]="email" required type="email" email placeholder="Ingrese correo electónico">
  </mat-form-field>
  <div  class="mensaje">
    <i class="fas fa-check" style="padding-right: 5px;padding-top: 4px;color:#29a884"></i><span style="text-align: center;">Para recuperar su contraseña debe ingresar el correo del usuario registrado, una vez validado se enviara a su correo la nueva contraseña</span>
  </div>
  <div class="dialog-buttons">
    <button mat-raised-button class="btn_olive" (click)="guardar()" [disabled]="datosCompletados()">Resetear contraseña</button>&nbsp;
    <button mat-raised-button class="btn_danger" (click)="cerrar()">Cancelar</button>
  </div>
</div>

